import { makeStyles, Grid } from "@material-ui/core"
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants"
import React, { useContext, useState } from "react"
import { FormContext } from "../../context/FormContext"
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui"
import { useSelectOption } from "App/hooks"
import {
  defaultToastError,
  defaultToastSuccess,
  convertToValidPrice,
  formatRupiah,
  isNull,
} from "App/utils/helpers"
import { getPoListById, urlCreateBarang, urlUpdateBarang } from "../../helpers"
import { LIST_URL_WAREHOUSE } from "utils/warehouse"

export const RESET_STATE_PO_BARANG = {
  id: "",
  po_id: "",
  name: "",
  barang_id: "",
  satuan_id: null,
  satuan_name: "Pilih Satuan",
  qty: 1,
  harga: "0",
  harga2: "0",
  disc: "",
}

export const STYLE_WMS_PO = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
})

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
]

export const ModalBarang = ({
  setShowModal,
  formBarang,
  setFormBarang,
  setNewDataPoList,
  setListPO,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT)
  const satuan = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterSatuan.get,
    TYPE_INSTANCE4,
  )

  const { formData } = useContext(FormContext)

  const handleChange = (text) => (e) => {
    setFormBarang({
      ...formBarang,
      [text]: e.target.value,
    })
  }

  const create = async () => {
    const api = await instance4.post(urlCreateBarang, {
      po_id: formData.idpo,
      barang_id: formBarang.barang_id,
      satuan_id: formBarang.satuan_id,
      qty: formBarang.qty,
      disc: formBarang.disc,
      set_disc:
        (formBarang.disc / 100) * convertToValidPrice(formBarang.harga2),
      harga: convertToValidPrice(formBarang.harga2),
    })
    return api
  }

  const update = async () => {
    const api = await instance4.post(urlUpdateBarang, {
      id: formBarang.id,
      po_id: formData.idpo,
      barang_id: formBarang.barang_id,
      satuan_id: formBarang.satuan_id,
      qty: formBarang.qty,
      disc: formBarang.disc,
      set_disc:
        (formBarang.disc / 100) * convertToValidPrice(formBarang.harga2),
      harga: convertToValidPrice(formBarang.harga2),
    })
    return api
  }

  // useEffect(() => {
  //   setFormBarang({
  //     ...formBarang,
  //     harga: convertToValidPrice(formBarang.harga2),
  //   });
  // }, [formBarang.harga2]);

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (isNull(formBarang.satuan_id)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Satuan tidak boleh kosong")
    } else if (isNull(formBarang.qty)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
      defaultToastError("Banyak tidak boleh kosong")
    } else {
      try {
        if (isNull(formBarang.id)) {
          const res = await create()
          if (res.data.status === 200) {
            await succesCreateOrUpdate("Menambah")
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            defaultToastError(res.data.message)
          }
        } else {
          const res = await update()
          if (res.data.status === 200) {
            await succesCreateOrUpdate("Mengupdate")
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
            defaultToastError(res.data.message)
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
        defaultToastError(error?.response?.data?.message)
      }
    }
  }

  const succesCreateOrUpdate = async (label) => {
    defaultToastSuccess(`Berhasil ${label} Barang`)
    const res = await getPoListById(formData.idpo)
    setListPO(res.data)
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT)
    setShowModal(false)
  }

  return (
    <Modal title={`Tambah Barang`} show={setShowModal} width="40%">
      {formData.idpo === "" ? (
        <p className="mt-2 mb-2 text-center">
          Silahkan buka transaksi terlebih dahulu
        </p>
      ) : (
        <form action="POST" onSubmit={(e) => handleSubmit(e)}>
          <p className="mt-1 mb-1">{formBarang.name}</p>
          <Grid container spacing={1}>
            <InputTextMaster
              type="hidden"
              name="barang_id"
              id="barang_id"
              readOnly={true}
              value={formBarang.barang_id}
            />
            <Grid item sm={4}>
              <InputOptionMaster
                name="satuan_id"
                label="SATUAN"
                id="satuan_id"
                withSearch={true}
                data={satuan}
                value={formBarang.satuan_id}
                labelValue={formBarang.satuan_name}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormBarang({
                      ...formBarang,
                      satuan_id: null,
                      satuan_name: "Pilih Satuan",
                    })
                  } else {
                    setFormBarang({
                      ...formBarang,
                      satuan_id: e.value,
                      satuan_name: e.label,
                    })
                  }
                }}
              />
            </Grid>
            <Grid item sm={2}>
              <InputTextMaster
                name="qty"
                label="BANYAK"
                id="qty"
                value={formBarang.qty}
                onChange={handleChange("qty")}
                placeholder="Banyak"
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name="harga"
                label="HARGA"
                id="harga"
                placeholder="0"
                value={formBarang.harga2}
                onInput={(e) => {
                  let val = e.target.value
                  setFormBarang({
                    ...formBarang,
                    harga2: formatRupiah(val),
                  })
                }}
              />
            </Grid>

            <Grid item sm={3}>
              <InputTextMaster
                name="disc"
                label="DISC %"
                id="disc"
                value={formBarang.disc}
                onChange={handleChange("disc")}
                placeholder="%"
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MasterButton
              className={"mt-1"}
              type="submit"
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.state}
              size="md"
            />
          </Grid>
        </form>
      )}
    </Modal>
  )
}
